import { executeMutation } from "utils/services/apiServices";
import { showSnackbar } from "utils/snack_bar/store/action";
import { actionTypes, AuthUserProps, LoginProps, UserProps } from "./actionType";
import { LOGIN } from "../graphql/mutation";
import { flattenRoleActions, resolveSuperAdmin, roleNames } from "utils/helpers/userAuthorities";

export const loginRequest = () => ({
  type: actionTypes.LOGIN_REQUEST,
});

export const loginSuccess = (payload: AuthUserProps) => ({
  type: actionTypes.LOGIN_SUCCESS,
  payload,
});

export const loginFail = (payload: string) => ({
  type: actionTypes.LOGIN_FAIL,
  payload,
});

export const authLogin = (input: LoginProps) => {
  return async (dispatch: any) => {
    try {
      await dispatch(loginRequest());
      const response = await executeMutation(LOGIN, input);
      const jsonData = response.data?.login;
      if (jsonData?.error) {
        const errorMessage = jsonData.error.message;
        dispatch(loginFail(errorMessage));
        dispatch(showSnackbar(`Error: ${errorMessage}`));
        return;
      }
      const payload: AuthUserProps = {
        token: jsonData.data.token,
        user: jsonData.data.user,
      };
      const user: UserProps = jsonData.data.user;
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem(
        "actions",
        JSON.stringify(flattenRoleActions(user.roles))
      );
      sessionStorage.setItem(
        "superAdmin",
        JSON.stringify(resolveSuperAdmin(roleNames(user.roles)))
      );
      dispatch(loginSuccess(payload));
    } catch (error: any) {
      dispatch(loginFail("Something went wrong"));
    }
  };
};


export const resetAuth = () => ({
    type: actionTypes.RESET_AUTH,
});

export const ResetAuth = () => {
    return async (dispatch: any) => {
        await dispatch(resetAuth());
    };
};

